import * as types from './types';

const showSnackbar = (payload) => ({
  type: types.UI_SHOW_SNACKBAR,
  payload,
});

const clearSnackbar = () => ({
  type: types.UI_SNACKBAR_CLEAR,
});

const showSidebar = (payload) => ({
  type: types.UI_SHOW_SIDEBAR,
  payload,
});

const showList = (payload) => ({
  type: types.UI_SHOW_LIST,
  payload,
});

export const handleShowSnackbar = (data) => {
  return (dispatch) => {
    dispatch(showSnackbar(data));
  };
};

export const handleClearSnackbar = () => {
  return (dispatch) => {
    dispatch(clearSnackbar());
  };
};

export const handleShowSidebar = (open) => {
  return (dispatch) => {
    dispatch(showSidebar({ open }));
  };
};

export const handleShowList = (open) => {
  return (dispatch) => {
    dispatch(showList({ open }));
  };
};
